@if(isLoading){
<div class="mi-products">
    <mi-genral-skeleton></mi-genral-skeleton>
</div>

}
@else{
<div class="mi-products container" tabindex="-1" miFocusOnTab>
    <div class="mi-panel-wrraper standart">
        <div class="row justify-content-center">
            <div class="col-12 mi-panel-content">

                <div class="mi-header-wrraper mc-my-3">
                    <span class="mi-header">{{productTitle}}</span>
                    @if(!isSingleProduct()){
                    <mc-button [label]="'מחיקת מוצר'" class="mi-white-button mi-remove-product" [icon]="'icon-trash-2'"
                        (click)="deleteProduct()"></mc-button>
                    }
                </div>

                <div class="mi-white-panel with-shadow">

                    <div class="mi-back ">
                        <i class="pi pi-fw pi-chevron-right"></i>
                        <span (click)="previousTab()" id="mi-product-back" tabindex="0" role="button"
                            (keyup.enter)="previousTab()">{{genericText?.back}}
                        </span>
                    </div>

                    @if (this.formisForm.fields.length> 0) {
                    <mc-field-form [formisForm]="formisForm">
                    </mc-field-form> }

                </div>

            </div>
        </div>
        <div class="row justify-content-center justify-content-md-start ">
            <div class="col-12 col-md-8 col-xl-4">
                @if(maxProductsReached && isLastProduct()){
                <div class="mc-pt-3">
                    <mc-info level="warning" class="col-12  mc-mt-4 mc-pt-1">
                        {{maxProductsInfoMessage()}}
                    </mc-info>
                </div>
                }
                <div class="mi-product-navigation row justify-content-center   mc-pt-1">
                    <div class=" col-6 mi-add-product">
                        <mc-button [disabled]="maxProductsReached|| !isLastProduct()" [label]="productsText?.addProduct"
                            (click)="createNewProduct()"></mc-button>
                    </div>
                    <div class="  col-6 mi-next">
                        <mc-button [label]="genericText?.next + ' >'" (click)="nextTab()"></mc-button>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
}
<mc-dialog [dialogProperties]="dialogProperties">
    <div class="d-flex flex-column align-items-end text-end">
        <b> {{productsText.dialogRemoveProduct?.textPart1}}</b>
        <span>{{productsText.dialogRemoveProduct?.textPart2}} </span>
    </div>
</mc-dialog>